<template>
  <div class="container-fluid map_bg">
    <div class="row">
      <div class="map_main position-relative">
        <img src="images/map.png" class="img-fluid" />
        <img
          src="images/waiting.gif"
          class="img-fluid waiting adventure pos-abs"
          v-if="stakes['advanture'].locked"
        />
        <a
          href="javascript:void(0)"
          @click="showMyModal('Advanture', 'advanture')"
          class="map_link map-label adventure"
        >
          Adventure</a
        >
        <img
          src="images/waiting.gif"
          class="img-fluid waiting horse_carriage pos-abs"
          v-if="stakes['stagecoach'].locked"
        />
        <a
          href="javascript:void(0)"
          @click="showMyModal('Stagecoach Raid', 'stagecoach')"
          class="map_link map-label horse_carriage"
        >
          Stagecoach Raid</a
        >
        <img
          src="images/waiting.gif"
          class="img-fluid waiting bank_robbery pos-abs"
          v-if="stakes['bankrobbery'].locked"
        />
        <a
          href="javascript:void(0);"
          @click="showMyModal('Bank Robbery', 'bankrobbery')"
          class="map_link map-label bank_robbery"
        >
          Bank Robbery</a
        >
        <img
          src="images/waiting.gif"
          class="img-fluid waiting-lg raid_office pos-abs"
          v-if="stakes['sherifraid'].locked"
        />
        <a
          href="javascript:void(0)"
          @click="showMyModal('Sheriff', 'sherifraid')"
          class="map_link map-label raid_office"
        >
          Sheriff's office Raid</a
        >
      </div>
    </div>
    <StakingModal
      :mode="modalName"
      v-if="showMdl"
      v-on:w-modal-hide-click="showMdl = false"
    />
    <PlayerModal
      v-if="stakeModal"
      :game="game"
      :mode="modalName"
      v-on:w-modal-hide-click="stakeModal = false"
    />
  </div>
</template>

<script>
import StakingModal from "../components/Modal/StakingModal.vue";
import PlayerModal from "../components/Modal/PlayerModal.vue";
// import GameLoader from "../components/GameLoader.vue";
import ApiService from "@/services";
import { mapGetters } from "vuex";
export default {
  name: "MapView",
  components: {
    StakingModal,
    PlayerModal,
    // GameLoader
  },
  computed: {
    ...mapGetters(["stakes"]),
  },
  data() {
    return {
      isShow: false,
      stakeModal: false,
      showMdl: false,
      loading: true,
      showModal: false,
      modalName: "",
      game: null,
      gameModes: {
        bankrobbery: { locked: false },
        advanture: { locked: false },
        stagecoach: { locked: false },
        sherifraid: { locked: false },
      },
    };
  },
  created() {
    ApiService.getCurrentGames((res) => {
      res.details.map(async (item) => {
        let row = item.value;
        row.locked = ApiService.isExpired(row.end_at);
        this.gameModes[item.key] = row;
      });
      this.$store.commit("addStake", this.gameModes);
      this.loading = false;
    });
    ApiService.getInventory((res) => {
      let myInventory = res.filter((i) => i.value.schema == "resource");
      this.$store.commit("addResources", myInventory);
    });
  },
  methods: {
    showMyModal(card, mode) {
      if (this.stakes[mode].locked) {
        this.stakeModal = true;
        this.game = this.stakes[mode];
        this.modalName = mode;
      } else {
        this.showMdl = card;
        this.modalName = mode;
      }
    },
  },
};
</script>

<style scoped>
.map_main {
  text-align: center;
  width: 820px;
  display: block;
  margin: 70px auto 0;
}

.raid_office {
  top: 37%;
  right: 0%;
  /* width: 12%; */
}
.adventure-loader {
  left: 105px;
  top: 28%;
}
.bank_robbery {
  top: 37%;
  left: 48%;
  /* padding: 30px 15px 0 5px; */
}
.horse_carriage {
  left: 236px;
  bottom: 28%;
  /* width: 110px; */
  /* padding: 30px 0px 0px; */
}
.map_link {
  position: absolute;
  color: #fff;
  font-size: 13px;
  font-family: "Skranji", cursive !important;
  text-transform: uppercase;
  text-shadow: 1px 2px 2px #000000;
  transition: all 0.5s;
  /* font-family: "WesternBangBang-Regular"; */
}
.map_link:hover {
  color: orange;
  transform: translateY(-10px);
}
.adventure {
  top: 40%;
  left: 105px;
  /* padding: 60px 50px 0 50px; */
}
.map_bg {
  background-image: url("/images/map_bg.png");
  height: 100%;
  width: 100%;
  background-color: #875724;
  background-repeat: no-repeat;
  background-size: cover;
  /* position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;*/
}
img.adventure {
  width: 82px;
  height: 11px;
  top: 47%;
}
img.bank_robbery {
  width: 106px;
  top: 44%;
  height: 12px;
}
img.horse_carriage {
  width: 123px;
  top: 74%;
}
.waiting-lg {
  width: 142px;
  top: 43%;
}
@media (max-width: 768px) {
  .map_link {
    font-size: 10px;
  }
  .adventure {
    top: 47%;
    left: 50px;
    /* padding: 0px 0px 0 0px; */
  }
  .horse_carriage {
    left: 75px;
    bottom: 36%;
    /* padding: 10px 0px 0px; */
  }
  .bank_robbery {
    top: 40%;
    left: 40%;
  }
  .raid_office {
    top: 50%;
    right: 15%;
    width: 30%;
  }
  .map_main {
    display: flex;
    align-items: center;
    height: 500px;
  }
}
</style>